<template>
    <div class="subscribe-page ac">
    <a class="logo" href="#/"><img src="static/images/logo1.png" /></a>
		<div class="unsub-btn mt100 por">
			<div class="mt100">
				<div class="register-t fs40 fw7">10+ Tax LKR/Day</div>
				<div class="button active fs50" style="font-size:70px;line-height:120px;">Register</div>
			</div>
		</div>
		<div class="sub-bottom ac fs40 mt100">
			<router-link :to="{path:'/faq'}"><span>{{$t('FAQs')}}</span><img src="static/images/gantan.png"></router-link>
			<router-link :to="{path:'/faq'}"><span>{{$t('T_C')}}</span><img src="static/images/gantan.png"></router-link>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

        return {
			notFound:false,

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){

	},
    methods: {
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/Home/homeData',null,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/subscribe.vue